function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.20289 89.3176L8.42619 89.2052L8.20289 89.3176ZM94.0204 214.511L94.2648 214.564L94.0204 214.511ZM8.42619 89.2052C-2.50911 67.484 -0.483924 47.2824 11.3571 32.5099C23.2072 17.7261 44.928 8.33022 73.4776 8.33022V7.83022C44.829 7.83022 22.9406 17.2592 10.9669 32.1972C-1.0158 47.1465 -3.0289 67.5635 7.97959 89.43L8.42619 89.2052ZM7.97959 89.43C13.6741 100.741 22.6216 110.874 32.6404 120.54C37.6506 125.374 42.9324 130.096 48.2127 134.791C53.4942 139.487 58.7738 144.156 63.7856 148.893C83.8441 167.847 99.5214 187.784 93.776 214.459L94.2648 214.564C100.072 187.601 84.1919 167.488 64.129 148.529C59.1105 143.787 53.8244 139.111 48.5449 134.417C43.2642 129.722 37.9895 125.007 32.9876 120.181C22.9821 110.527 14.0827 100.441 8.42619 89.2052L7.97959 89.43ZM93.776 214.459C87.994 241.302 89.028 264.944 99.3767 281.884C109.736 298.842 129.388 309.019 160.678 309.019V308.519C129.497 308.519 110.043 298.385 99.8034 281.624C89.5529 264.844 88.4937 241.357 94.2648 214.564L93.776 214.459ZM160.925 13.3506C116.337 27.3347 100.608 68.4409 103.874 107.666C105.508 127.281 111.89 146.445 121.802 161.548C131.713 176.65 145.166 187.709 160.948 191.07L161.052 190.581C145.437 187.256 132.083 176.302 122.22 161.273C112.357 146.246 106 127.163 104.373 107.625C101.118 68.5436 116.786 27.7181 161.075 13.8277L160.925 13.3506ZM73.4776 8.33022C89.0378 8.33022 101.722 5.68745 112.099 1.2297L111.901 0.770298C101.596 5.19733 88.9807 7.83022 73.4776 7.83022V8.33022Z",
  fill: "url(#paint0_linear_7660_141601)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_7660_141601",
  x1: 161,
  y1: 154.885,
  x2: 1,
  y2: 154.885,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#007AFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00B2FF"
})));

function SvgBlueVectorTop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 310,
    viewBox: "0 0 143 310",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueVectorTop);
export default __webpack_public_path__ + "static/media/BlueVectorTop.57bf7c9c24af6fa07b74c94370d306ab.svg";
export { ForwardRef as ReactComponent };